import { Button } from "@ui/button"
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@ui/tooltip"
import { cn } from "@/lib/utils"

interface ActionTooltipButtonProps {
    icon: React.ReactNode
    disabled?: boolean
    tooltip: string
    size?: "default" | "sm" | "lg" | "icon" | "xs"
    variant?: "default" | "destructive" | "outline" | "secondary" | "ghost" | "link" | "icon"
    className?: string
    onClick: () => void
}
export function ActionTooltipButton({ icon, disabled = false, tooltip, size = "default", variant = "default", className, onClick }: Readonly<ActionTooltipButtonProps>) {
    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>
                    <Button
                        onClick={onClick}
                        variant={variant}
                        size={size}
                        disabled={disabled}
                        className={cn(className)}
                    >
                        {icon}
                    </Button>
                </TooltipTrigger>
                <TooltipContent>
                    <p>{tooltip}</p>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    )
}